import React from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";
import ChevronIcon from "../icons/ChevronIcon";
import "./index.scss";

const CHEVRON_DIRECTION = { previous: "left", next: "right" };

const NavArrowButton = ({
  direction,
  ariaLabel,
  onClick = undefined,
  disabled = false,
  className = "",
  ...props
}) => (
  <button
    type="button"
    className={classNames("nav-arrow-button", `nav-arrow-button--${direction}`, className)}
    onClick={onClick}
    disabled={disabled}
    aria-label={ariaLabel}
    {...props}
  >
    <span className="nav-arrow-button__icon" aria-hidden="true">
      <ChevronIcon direction={CHEVRON_DIRECTION[direction]} />
    </span>
  </button>
);

NavArrowButton.propTypes = {
  direction: PropTypes.oneOf(["previous", "next"]).isRequired,
  ariaLabel: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default NavArrowButton;
